import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="2">
      <path d="M3 11v8M13 3v3M9 4h8M2 15h4" />
      <path
        d="M6 11v7a1 1 0 0 0 1 1h8.465a1 1 0 0 0 .832-.445l1.406-2.11a1 1 0 0 1 .832-.445H20a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2 0V8a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v2h0-2a1 1 0 0 0-1 1z"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
